import angular from 'angular';
import ngCookies from 'angular-cookies';

// Load components.
import trackingCodeComponent from './components/trackingcode/tracking-code.component';
import trackingResultsComponent from './components/trackingresults/tracking-results.component';
import overlayComponent from './components/overlay/overlay-template.component';
import recentlyTrackedComponent from './components/recentlytracked/recently-tracked.component';
import googleRecaptchaComponent from './components/googlerecaptcha/google-recaptcha.component';
import pfwOverlay from './components/pfwOverlay/pfwOverlay.component';
import gpsMapComponent from './components/gpsMap/gpsMap.component';

const componentsModule = angular
  .module('app.components', [ngCookies])
  .component('trackingcode', trackingCodeComponent)
  .component('overlay', overlayComponent)
  .component('pfwOverlay', pfwOverlay)
  .component('trackingresults', trackingResultsComponent)
  .component('recentlytracked', recentlyTrackedComponent)
  .component('googlerecaptcha', googleRecaptchaComponent)
  .component('gpsMapComponent', gpsMapComponent)
  .name;

export default componentsModule;


// WEBPACK FOOTER //
// ./src/components.module.js